<script>
  import { onMount } from 'svelte';

  import Viewport from '@components/Viewport.svelte';

  import { getCurrentUserStore } from '@stores/current_user';

  import Header from '@components/Header.svelte';

  let currentUser = getCurrentUserStore('default');

  export let title = 'Frequently Asked Questions';
  export let titleStyle;
  export let titleClass;
  export let description;
  export let opened = false;
  export let showHeader = false;

  import jQuery from 'jquery';

  onMount(() => {
    if (!opened) {
      jQuery('.answer').hide();
    }

    let handleClick = function () {
      if (jQuery(this).parent().find('.answer:visible').length > 0) {
        jQuery(this).parent().find('.answer').slideUp('fast');
        jQuery(this).parent().removeClass('opened');
      } else {
        jQuery(this).parent().find('.answer').slideDown('fast');
        jQuery(this).parent().addClass('opened');
      }
    };

    jQuery('.question-answer h2').click(handleClick);
    jQuery('.question-answer .arrow').click(handleClick);
  });
</script>

<style>
  * :global(.ui-container) {
    max-width: 1000px;
    padding-top: 20px;
    margin: auto;
    padding-left: 10px;
    padding-right: 10px;
  }

  * :global(a) {
    color: rgb(17, 85, 204);
  }

  * :global(h1) {
    font-size: 30px;
    line-height: 42px;
  }

  * :global(h2) {
    color: #7054dc;
    cursor: pointer;
    margin-top: 35px;
    font-size: 20px;
  }

  * :global(.closed > h2) {
    padding-bottom: 10px;
    border-bottom: 2px solid #e8e8e8;
  }

  * :global(.closed > h2) {
    padding-bottom: 10px;
    border-bottom: 2px solid #e8e8e8;
  }

  * :global(.answer) {
    opacity: 0.75;
  }

  * :global(.closed .answer) {
    display: none;
  }

  @media only screen and (max-width: 999px) {
    * :global(.login-btn) {
      display: none;
    }
  }
</style>

<Viewport let:mobile TABLET_MIN={1000}>
  <div style={mobile ? 'padding-left: 20px; padding-right: 20px' : ''}>
    {#if showHeader}
      <Header currentUser={currentUser} mobile={mobile} currentPage="faq" />
    {/if}

    <div class="ui-container" style="padding-top: 30px">
      <div class="ui-detail-view">
        <div class="ui-detail-view-content">
          <h1 class="faq-title {titleClass}" style={titleStyle}>{title}</h1>
          {#if description}
            <h4 style="font-weight: 400; line-height: 1.3;">{description}</h4>
          {/if}
          <br />
          <slot />
        </div>
      </div>
    </div>

    <div style="height: 100px">&nbsp;</div>
  </div>
</Viewport>
